export default __webpack_public_path__ + "static/media/ico_arrow_up_black.23baca0d.svg";